const React = require('react')
const { Suspense } = React
const { render } = require('react-dom')
const { BrowserRouter } = require('react-router-dom')
const { CookiesProvider } = require('react-cookie')
const { NetworkConfigProvider } = require('@contexts')
const { LoadingSpinner } = require('@components')

require('bootstrap/dist/css/bootstrap.css')

require('@styles/main.style.css')

const App = require('./App')

const rootElement = document.getElementById('root')
render(
    <CookiesProvider>
        <NetworkConfigProvider>
            <Suspense fallback={<LoadingSpinner />}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Suspense>
        </NetworkConfigProvider>
    </CookiesProvider>,
    rootElement
)
